import { render, staticRenderFns } from "./MedicalAppointmentForm.vue?vue&type=template&id=4554ba9c&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4554ba9c",
  null
  
)

export default component.exports